import React, { useEffect, useRef } from 'react';

import { mount, unmount } from 'redom';

import TransitionInput from './';

function TransitionInputReact(props) {

  var containerReference = useRef(null);
  var transitionInputReference = useRef(null);

  useEffect(function onMount() {

    var container = containerReference.current;

    var transitionInput = new TransitionInput({
      transition: props.transition,
      onChange: props.onChange
    });

    transitionInputReference.current = transitionInput;

    mount(container, transitionInput);

    return function onUnmount() {
      unmount(container, transitionInputReference.current);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(function onTransitionChange() {

    if (transitionInputReference.current === null) {
      return;
    }

    transitionInputReference.current.update({
      transition: props.transition,
      onChange: props.onChange
    });

  }, [props.transition, props.onChange]);

  function renderMain() {

    return <div className="transition-input-react-wrapper" ref={containerReference}></div>;

  }

  return renderMain();

}

export default TransitionInputReact;